import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import Breadcrumb from '@/components/feature/Breadcrumb';

export default function AboutPage() {
  return (
    <div className="min-h-screen bg-background-50">
      <Navbar />

      <main className="pt-20 pb-10">
        <div className="max-w-[900px] mx-auto px-4 md:px-6">
          <Breadcrumb
            items={[
              { label: '首页', href: '/' },
              { label: '关于我们' },
            ]}
          />

          {/* Hero */}
          <section className="text-center py-10 md:py-14">
            <h1 className="text-3xl md:text-4xl font-black font-heading text-foreground-950 mb-4">
              关于黑料舍
            </h1>
            <p className="text-lg text-secondary-500 max-w-2xl mx-auto leading-relaxed">
              让隐藏的秘密无处遁形——黑料舍，专注深度内幕与独家爆料的内容平台。
            </p>
          </section>

          {/* Brand Introduction */}
          <section className="mb-12">
            <h2 className="text-xl font-bold font-heading text-foreground-900 mb-4 flex items-center gap-2">
              <i className="ri-building-line text-primary-500"></i>
              品牌介绍
            </h2>
            <div className="bg-background-50 border border-secondary-200/60 rounded-xl p-6 md:p-8">
              <p className="text-foreground-700 leading-relaxed mb-4">
                黑料舍成立于2024年，是国内领先的深度内幕与独家爆料内容平台。我们汇聚了一群经验丰富的调查记者和行业内部人士，致力于为公众还原事实真相，让隐藏的秘密无处遁形。
              </p>
              <p className="text-foreground-700 leading-relaxed mb-4">
                我们的报道覆盖娱乐圈、商业内幕、社会揭秘、政界风云、科技黑幕等多个领域，每日更新最新的独家爆料和深度调查。每一篇报道都经过严格的核实流程，确保内容真实可靠。
              </p>
              <p className="text-foreground-700 leading-relaxed">
                黑料舍坚持以独立、客观、深度的报道理念，为读者提供高质量的内容体验。我们不追逐流量，不制造谣言，只做一件事——揭露真相。
              </p>
            </div>
          </section>

          {/* Core Values */}
          <section className="mb-12">
            <h2 className="text-xl font-bold font-heading text-foreground-900 mb-4 flex items-center gap-2">
              <i className="ri-shield-star-line text-primary-500"></i>
              核心价值
            </h2>
            <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
              {[
                {
                  icon: 'ri-search-eye-line',
                  title: '深度调查',
                  desc: '每篇报道都经过深入调查和多方核实，绝不发布未经证实的消息。',
                },
                {
                  icon: 'ri-shield-check-line',
                  title: '独立客观',
                  desc: '不接受任何形式的利益输送，保持独立客观的报道立场。',
                },
                {
                  icon: 'ri-user-heart-line',
                  title: '守护公众',
                  desc: '以公众利益为出发点，揭露损害公众权益的各类黑幕。',
                },
              ].map((item) => (
                <div
                  key={item.title}
                  className="bg-background-50 border border-secondary-200/60 rounded-xl p-5 text-center"
                >
                  <div className="w-12 h-12 flex items-center justify-center rounded-xl bg-primary-100 mx-auto mb-3">
                    <i className={`${item.icon} text-primary-600 text-xl`}></i>
                  </div>
                  <h3 className="text-base font-bold font-heading text-foreground-900 mb-2">{item.title}</h3>
                  <p className="text-sm text-secondary-500 leading-relaxed">{item.desc}</p>
                </div>
              ))}
            </div>
          </section>

          {/* Stats */}
          <section className="mb-12">
            <h2 className="text-xl font-bold font-heading text-foreground-900 mb-4 flex items-center gap-2">
              <i className="ri-bar-chart-box-line text-primary-500"></i>
              平台数据
            </h2>
            <div className="grid grid-cols-2 sm:grid-cols-4 gap-4">
              {[
                { value: '485', label: '独家爆料', icon: 'ri-flashlight-line' },
                { value: '1280万+', label: '月活跃读者', icon: 'ri-user-line' },
                { value: '98.7%', label: '内容真实率', icon: 'ri-check-double-line' },
                { value: '50+', label: '调查记者', icon: 'ri-team-line' },
              ].map((stat) => (
                <div
                  key={stat.label}
                  className="bg-background-50 border border-secondary-200/60 rounded-xl p-4 text-center"
                >
                  <div className="w-10 h-10 flex items-center justify-center rounded-xl bg-accent-100 mx-auto mb-2">
                    <i className={`${stat.icon} text-accent-600 text-lg`}></i>
                  </div>
                  <p className="text-xl md:text-2xl font-black font-heading text-accent-600">
                    {stat.value}
                  </p>
                  <p className="text-xs text-secondary-500 mt-1">{stat.label}</p>
                </div>
              ))}
            </div>
          </section>

          {/* FAQ */}
          <section className="mb-12">
            <h2 className="text-xl font-bold font-heading text-foreground-900 mb-4 flex items-center gap-2">
              <i className="ri-question-answer-line text-primary-500"></i>
              常见问题
            </h2>
            <div className="flex flex-col gap-3">
              {[
                {
                  q: '黑料舍的内容来源是什么？',
                  a: '我们的内容来自调查记者的独立采访、内部人士的独家爆料、公开信息的深度挖掘以及多方信源的交叉验证。所有发布内容均经过严格的审核流程。',
                },
                {
                  q: '如何向黑料舍提供爆料线索？',
                  a: '你可以通过页面底部的联系方式或"我要爆料"按钮向我们提供线索。我们承诺对所有爆料人信息严格保密，并为重大独家线索提供奖励。',
                },
                {
                  q: '黑料舍的内容是否可信？',
                  a: '我们坚持多源核实原则，每条重要报道都需要至少两个独立信源的交叉验证。对于无法完全核实的信息，我们会明确标注"待核实"状态。',
                },
                {
                  q: '如果发现内容有误怎么办？',
                  a: '如发现报道中存在事实性错误，请立即通过联系方式告知我们。我们会在核实后第一时间发布更正声明，并在原文章中标注更正内容。',
                },
              ].map((faq, index) => (
                <details key={index} className="group bg-background-50 border border-secondary-200/60 rounded-xl">
                  <summary className="flex items-center justify-between p-4 cursor-pointer font-medium text-foreground-800 text-sm list-none">
                    {faq.q}
                    <i className="ri-arrow-down-s-line text-secondary-400 group-open:rotate-180 transition-transform text-base"></i>
                  </summary>
                  <div className="px-4 pb-4">
                    <p className="text-sm text-secondary-600 leading-relaxed">{faq.a}</p>
                  </div>
                </details>
              ))}
            </div>
          </section>

          {/* Contact */}
          <section className="mb-12" id="contact">
            <h2 className="text-xl font-bold font-heading text-foreground-900 mb-4 flex items-center gap-2">
              <i className="ri-mail-send-line text-primary-500"></i>
              联系我们
            </h2>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
              <div className="bg-background-50 border border-secondary-200/60 rounded-xl p-6">
                <h3 className="text-base font-bold font-heading text-foreground-900 mb-4">联系方式</h3>
                <div className="flex flex-col gap-3">
                  <div className="flex items-center gap-3">
                    <div className="w-9 h-9 flex items-center justify-center rounded-lg bg-primary-100 flex-shrink-0">
                      <i className="ri-mail-line text-primary-600"></i>
                    </div>
                    <div>
                      <p className="text-xs text-secondary-400">爆料邮箱</p>
                      <p className="text-sm text-foreground-800 font-medium">tips@heiliao.she</p>
                    </div>
                  </div>
                  <div className="flex items-center gap-3">
                    <div className="w-9 h-9 flex items-center justify-center rounded-lg bg-primary-100 flex-shrink-0">
                      <i className="ri-phone-line text-primary-600"></i>
                    </div>
                    <div>
                      <p className="text-xs text-secondary-400">商务合作</p>
                      <p className="text-sm text-foreground-800 font-medium">business@heiliao.she</p>
                    </div>
                  </div>
                  <div className="flex items-center gap-3">
                    <div className="w-9 h-9 flex items-center justify-center rounded-lg bg-primary-100 flex-shrink-0">
                      <i className="ri-map-pin-line text-primary-600"></i>
                    </div>
                    <div>
                      <p className="text-xs text-secondary-400">办公地址</p>
                      <p className="text-sm text-foreground-800 font-medium">北京市朝阳区建国路88号SOHO现代城A座</p>
                    </div>
                  </div>
                </div>
              </div>

              <ContactForm />
            </div>
          </section>
        </div>
      </main>

      <Footer />

      {/* FAQ Schema */}
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'FAQPage',
            mainEntity: [
              { '@type': 'Question', name: '黑料舍的内容来源是什么？', acceptedAnswer: { '@type': 'Answer', text: '我们的内容来自调查记者的独立采访、内部人士的独家爆料、公开信息的深度挖掘以及多方信源的交叉验证。所有发布内容均经过严格的审核流程。' } },
              { '@type': 'Question', name: '如何向黑料舍提供爆料线索？', acceptedAnswer: { '@type': 'Answer', text: '你可以通过页面底部的联系方式或"我要爆料"按钮向我们提供线索。我们承诺对所有爆料人信息严格保密，并为重大独家线索提供奖励。' } },
              { '@type': 'Question', name: '黑料舍的内容是否可信？', acceptedAnswer: { '@type': 'Answer', text: '我们坚持多源核实原则，每条重要报道都需要至少两个独立信源的交叉验证。对于无法完全核实的信息，我们会明确标注"待核实"状态。' } },
              { '@type': 'Question', name: '如果发现内容有误怎么办？', acceptedAnswer: { '@type': 'Answer', text: '如发现报道中存在事实性错误，请立即通过联系方式告知我们。我们会在核实后第一时间发布更正声明，并在原文章中标注更正内容。' } },
            ],
          }),
        }}
      />
    </div>
  );
}

function ContactForm() {
  const [formData, setFormData] = useState({ name: '', email: '', subject: '', message: '' });
  const [status, setStatus] = useState<'idle' | 'loading' | 'success' | 'error'>('idle');
  const [errorMsg, setErrorMsg] = useState('');
  const formRef = useRef<HTMLFormElement>(null);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    setFormData((prev) => ({ ...prev, [e.target.name]: e.target.value }));
  };

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    setStatus('loading');
    setErrorMsg('');

    try {
      const form = formRef.current;
      if (!form) return;
      const fd = new FormData(form);
      const honeypot = fd.get('phone_alt') as string;
      if (honeypot && honeypot.trim() !== '') {
        setStatus('success');
        setFormData({ name: '', email: '', subject: '', message: '' });
        return;
      }

      const body = new URLSearchParams();
      fd.forEach((value, key) => {
        if (key !== 'phone_alt' || !(value as string).trim()) {
          body.append(key, value as string);
        }
      });

      const response = await fetch('https://readdy.ai/api/form/d9qs1svnahb7382ovej0', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: body.toString(),
      });

      const responseText = await response.text();
      let parsed: any;
      try { parsed = JSON.parse(responseText); } catch { parsed = {}; }

      if (!response.ok || parsed?.code !== 'OK') {
        const serverMsg = parsed?.meta?.message || parsed?.message || parsed?.meta?.detail || responseText || '提交失败';
        throw new Error(serverMsg);
      }

      setStatus('success');
      setFormData({ name: '', email: '', subject: '', message: '' });
    } catch (err: any) {
      setStatus('error');
      setErrorMsg(err.message || '提交失败，请稍后再试');
    }
  };

  return (
    <div className="bg-background-50 border border-secondary-200/60 rounded-xl p-6">
      <h3 className="text-base font-bold font-heading text-foreground-900 mb-4">发送消息</h3>
      {status === 'success' ? (
        <div className="text-center py-8">
          <div className="w-14 h-14 flex items-center justify-center rounded-full bg-accent-100 mx-auto mb-3">
            <i className="ri-check-line text-accent-600 text-2xl"></i>
          </div>
          <p className="text-foreground-800 font-medium">消息已发送！</p>
          <p className="text-sm text-secondary-500 mt-1">我们会尽快回复你。</p>
        </div>
      ) : (
        <form ref={formRef} onSubmit={handleSubmit} className="flex flex-col gap-3" data-readdy-form="">
          <div className="visually-hidden-field">
            <input type="text" name="phone_alt" tabIndex={-1} autoComplete="off" aria-hidden="true" readOnly />
          </div>
          <input
            type="text"
            name="name"
            value={formData.name}
            onChange={handleChange}
            placeholder="你的姓名"
            required
            className="px-3 py-2.5 text-sm rounded-lg border border-secondary-200 bg-background-50 text-foreground-800 placeholder-secondary-400 focus:outline-none focus:border-primary-400 transition-colors"
          />
          <input
            type="email"
            name="email"
            value={formData.email}
            onChange={handleChange}
            placeholder="你的邮箱"
            required
            className="px-3 py-2.5 text-sm rounded-lg border border-secondary-200 bg-background-50 text-foreground-800 placeholder-secondary-400 focus:outline-none focus:border-primary-400 transition-colors"
          />
          <input
            type="text"
            name="subject"
            value={formData.subject}
            onChange={handleChange}
            placeholder="消息主题"
            required
            className="px-3 py-2.5 text-sm rounded-lg border border-secondary-200 bg-background-50 text-foreground-800 placeholder-secondary-400 focus:outline-none focus:border-primary-400 transition-colors"
          />
          <textarea
            name="message"
            value={formData.message}
            onChange={handleChange}
            placeholder="请输入你的消息（不超过500字）"
            required
            maxLength={500}
            rows={4}
            className="px-3 py-2.5 text-sm rounded-lg border border-secondary-200 bg-background-50 text-foreground-800 placeholder-secondary-400 focus:outline-none focus:border-primary-400 transition-colors resize-none"
          ></textarea>
          <button
            type="submit"
            disabled={status === 'loading'}
            className="w-full py-2.5 text-sm font-semibold bg-primary-500 text-background-50 rounded-lg hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer disabled:opacity-60"
          >
            {status === 'loading' ? '发送中...' : '发送消息'}
          </button>
          {status === 'error' && (
            <p className="text-red-500 text-xs">{errorMsg}</p>
          )}
        </form>
      )}
    </div>
  );
}